import { Pencil } from 'lucide-react';
import React from 'react';
import { Trash2, UserMinus } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../global-components/src';
import { User } from '../global-components/src/types';
import { t } from 'i18next';

const EditAccount = ({ user }: { user: User | undefined }) => {
    const navigate = useNavigate();
    const { user: authUser } = useAuth();

    return (
        <>
        {user && user?.id == authUser?.id ? (
            <li>
                <ul className="ul-normal">
                    <span onClick={() => { navigate("/conta") } } className="dropdown-item cursor-pointer user-select-none">
                        <div className="div-icon-fix">
                            <><Pencil data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("user.editAccount")}</>
                        </div>
                    </span>
                </ul>
            </li>
        ): null}
        </>
    );
};

export default EditAccount;
